import React, { useEffect, useState } from "react"
import { Modal, ModalBody, Button, Card, CardBody, CardText, CardTitle, Col, FormGroup, Input, Row, Spinner, Table } from "reactstrap"

import { useWallet } from "../../../libs/useMetaMaskWallet"
import Web3 from "web3"

import ConnectWallet from "../../../Components/ConnectWallet"
import BreadCrumb from "../../../Components/BreadCrumb"
import { formatNumber } from "../../../utils"
import { useToast } from "../../../hooks/toast"
import { approve, stake, unStake, claim } from "../utils/stakingUtils"

const Staking = ({ pool }) => {
    const web3 = new Web3()
    const [isLoading, setIsLoading] = useState(false)
    const [processing, setProcessing] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [claimAmount, setClaimAmount] = useState(0)
    const [stakeAmount, setStakeAmount] = useState(0)
    const [inputStakeAmount, setInputStakeAmount] = useState(0)
    const [unStakeAmount, setUnStakeAmount] = useState(0)
    const [inputUnStakeAmount, setInputUnStakeAmount] = useState(0)

    const [yourStakeAmount, setYourStakeAmount] = useState(0)
    const [stakeIds, setStakeIds] = useState([])
    const [stakedAmountById, setStakedAmountById] = useState([])
    const [maxWithdrawById, setMaxWithdrawById] = useState(0)
    const [maxRewardsById, setMaxRewardsById] = useState(0)
    const [allowance, setAllowance] = useState(0)
    const [selectedId, setSelectedId] = useState() // tokenId for claiming reward
    const [contractDetails, setContractDetails] = useState({ name: "", symbol: "", totalSupply: 0 })
    const [claimableRewards, setClaimableRewards] = useState([]) // array of objects { id, reward }, where id == tokenId
    const [idoBalance, setIdoBalance] = useState(0)
    const [totalStaked, setTotalStaked] = useState(0)

    const toast = useToast()
    const wallet = useWallet()
    const minimumAmountToStake = 500

    const onRewardValueChange = (e, type) => {
        const value = e.target.value === "" ? 0 : e.target.value
        switch (type) {
            case "claim":
                setClaimAmount(value)
                break
            case "stake":
                setInputStakeAmount(parseFloat(value))
                setStakeAmount(toWei(value))
                break
            case "unstake":
                setInputUnStakeAmount(parseFloat(value))
                setUnStakeAmount(toWei(value))
                break
            default:
                return
        }
    }

    const handleApprove = async (amount) => {
        web3.setProvider(wallet.ethereum.provider)
        approve(web3, pool, wallet.account, amount, setProcessing, setMessage, setAllowed)
    }

    const handleStake = async (amount) => {
        web3.setProvider(wallet.ethereum.provider)
        stake(web3, pool, wallet.account, amount, null, null, 0, setProcessing, setMessage, handleResetForm)
    }

    const handleUnStake = async (tokenId, amount) => {
        web3.setProvider(wallet.ethereum.provider)
        unStake(web3, pool, wallet.account, tokenId, amount, setProcessing, setMessage, handleResetForm)
    }

    const handleClaim = async (rewardToken, tokenId, amount) => {
        web3.setProvider(wallet.ethereum.provider)
        claim(web3, pool, wallet.account, rewardToken, tokenId, amount, setProcessing, setMessage, handleResetForm)
    }

    const handleResetForm = async () => {
        setClaimAmount(0)
        setStakeAmount(0)
        setInputStakeAmount(0)
        setUnStakeAmount(0)
        setInputUnStakeAmount(0)
        window.location.reload()
    }

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const setAllowed = (amount) => {
        setAllowance(amount)
    }

    useEffect(() => {
        if (selectedId > 0) {
            let id = selectedId
            let arr = stakedAmountById
            let result = arr.find((el) => el.value == id)
            if (result) {
                setMaxWithdrawById(result.amount)
                setMaxRewardsById(result.reward / 1000000)
            } else {
                setMaxWithdrawById(0)
                setMaxRewardsById(0)
                toast.addInfo("There is no stake or reward for the selected Id")
            }
        } else {
            setMaxWithdrawById(0)
            setMaxRewardsById(0)
        }
    }, [selectedId])

    useEffect(() => {
        ;(async () => {
            setIsLoading(true)
            if (updateConnection() && wallet.account && wallet.chainId === pool.chainId && pool) {
                web3.setProvider(wallet.ethereum.provider)
                try {
                    let tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
                    let stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
                    let stakingContractName = await stakingContract.methods.name().call()
                    let stakingSymbol = await stakingContract.methods.symbol().call()
                    setContractDetails({
                        name: stakingContractName,
                        symbol: stakingSymbol
                    })
                    let urStakeAmount = await stakingContract.methods.getStakeAmount(wallet.account).call()
                    let balance = await tokenContract.methods.balanceOf(wallet.account).call()
                    let stakedBalance = await tokenContract.methods.balanceOf(pool.stakingContractAddress).call()
                    setIdoBalance(balance)
                    setTotalStaked(stakedBalance)

                    // let totalSupply = await stakingContract.methods.totalDepositAmount().call()

                    let allowancea = await tokenContract.methods.allowance(wallet.account, pool.stakingContractAddress).call()
                    setAllowance(allowancea)

                    let ids = await stakingContract.methods.getStakeTokenIds(wallet.account).call()
                    let idsA = ids.map((id) => {
                        return { value: id, label: id }
                    })
                    setStakeIds(idsA)

                    let stakedValuesById = await Promise.all(
                        ids.map(async (id) => {
                            let amount = await stakingContract.methods.stakes(id).call()
                            let reward = await stakingContract.methods.getClaimableReward(id).call()
                            return { value: id, label: id, amount: amount["0"], reward: reward }
                        })
                    )

                    setStakedAmountById(stakedValuesById)

                    setYourStakeAmount(urStakeAmount)

                    // for each tokenId, get its available reward
                    let claimableRewards = await Promise.all(
                        ids.map(async (id) => {
                            let rewardstart = await stakingContract.methods.getClaimableReward(id).call()
                            let reward = rewardstart / 1000000
                            return { id, reward }
                        })
                    )
                    setClaimableRewards(claimableRewards)
                    setIsLoading(false)
                } catch (err) {
                    setIsLoading(false)
                    console.log(err)
                }
            }
        })()
    }, [wallet])

    const updateConnection = () => {
        const x = wallet.status === "connected" && wallet.chainId === pool.chainId
        setIsConnectedToWallet(x)
        return x
    }

    const toWei = (numberToWei) => {
        return web3.utils.toWei(numberToWei.toString(), "ether")
    }

    const fromWei = (numberFromWei) => {
        return web3.utils.fromWei(numberFromWei.toString(), "ether")
    }

    const insufficientApproval = Number(allowance) < Number(stakeAmount)
    const lessThanMinStake = Number(stakeAmount) < Number(toWei(minimumAmountToStake))
    const insufficientBalance = Number(stakeAmount) > Number(idoBalance)
    const lessThanStaked = Number(unStakeAmount) <= Number(maxWithdrawById)

    const showApproveButton = () => {
        if (insufficientApproval && !lessThanMinStake && !insufficientBalance) return true
        return false
    }
    const disabledApproveButton = () => {
        if (pool.poolSymbol == "IGSP" || lessThanMinStake || stakeAmount == 0 || insufficientBalance || processing) return true
        return false
    }
    const disabledStakeButton = () => {
        if (isNaN(stakeAmount) || insufficientApproval || lessThanMinStake || Number(stakeAmount) == 0 || insufficientBalance || processing)
            return true
        return false
    }
    const disabledClaimButton = () => {
        if (!(selectedId > 0) || !stakeIds.length || selectedId === "Select the Token ID" || claimAmount > maxRewardsById || claimAmount <= 0)
            return true
        return false
    }
    const disabledUnstakeButton = () => {
        if (!(unStakeAmount > 0 && lessThanStaked) || processing) return true
        return false
    }

    return (
        <React.Fragment>
            <div className="content staking-page">
                <BreadCrumb items={[pool.breadCrumb]} />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} chainId={pool.chainId} onChange={updateConnection} />
                ) : isLoading ? (
                    <Modal isOpen={isLoading} centered={true}>
                        <ModalBody className="text-center h3">Loading...</ModalBody>

                        <ModalBody className="text-center">
                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                        </ModalBody>
                    </Modal>
                ) : (
                    <div className="staking-body">
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Contract Details</CardTitle>
                                        <Row>
                                            <Col lg={6}>
                                                <CardText className="card-text-label text-uppercase mb-1">Name </CardText>
                                                <div className="card-text-value">
                                                    {pool.poolSymbol == "IGSP" ? `OLD ${contractDetails.name}` : contractDetails.name}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="contract-details mt-md-4 mb-md-4">
                                            {/* lg # defines how wide column is */}
                                            {/* lg = set breakpoint for large screen */}
                                            {/* md = set breakpoint for medium screen */}
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">Minimum Stake Amount </CardText>
                                                <div className="card-text-value">
                                                    {minimumAmountToStake} {pool.tokenSymbol}
                                                </div>
                                            </Col>
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">Symbol </CardText>
                                                <div className="card-text-value">
                                                    {pool.poolSymbol == "IGSP" ? `OLD ${contractDetails.symbol}` : contractDetails.symbol}
                                                </div>
                                            </Col>
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">
                                                    Total Staked ({pool.tokenSymbol}){" "}
                                                </CardText>
                                                <div className="card-text-value">{formatNumber(fromWei(totalStaked), 2)}</div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Your Details</CardTitle>

                                        <div className="align-items-center your-details">
                                            <div className="balance-stake-wrap">
                                                <div className="ido-balance">
                                                    <CardText className="card-text-label text-uppercase">Your {pool.tokenSymbol} Balance </CardText>
                                                    <span className="card-text-value">{formatNumber(fromWei(idoBalance), 5)}</span>
                                                </div>

                                                <div className="stake-bg stake-ido">
                                                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                                                        <div className="stake-bg-left">
                                                            <CardText className="card-text-label text-uppercase">Your STAKE </CardText>
                                                            <span className="card-text-value">{formatNumber(fromWei(yourStakeAmount), 2)}</span>
                                                        </div>
                                                        <div className="stake-bg-right">
                                                            <FormGroup>
                                                                <div className="select-balance">
                                                                    <CardText className="card-text-label text-uppercase">
                                                                        <span
                                                                            className="amount-value"
                                                                            onClick={() => {
                                                                                setInputStakeAmount(fromWei(idoBalance))
                                                                                setStakeAmount(idoBalance)
                                                                            }}
                                                                        >
                                                                            max
                                                                        </span>
                                                                    </CardText>
                                                                </div>
                                                                <Input
                                                                    type="number"
                                                                    min={0}
                                                                    className="form-control w-100"
                                                                    value={inputStakeAmount}
                                                                    onFocus={(e) => e.target.select()}
                                                                    onChange={(e) => onRewardValueChange(e, "stake")}
                                                                    placeholder="Enter stake amount"
                                                                    disabled={processing}
                                                                ></Input>
                                                                {showApproveButton() ? (
                                                                    <Button
                                                                        className="btn submit-btn w-100 orange-btn text-uppercase"
                                                                        onClick={() => handleApprove(fromWei(stakeAmount))}
                                                                        style={{ width: "100%" }}
                                                                        disabled={disabledApproveButton()}
                                                                    >
                                                                        {!processing ? "Approve FIDO" : "Processing... "}
                                                                        {processing ? (
                                                                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                        ) : null}
                                                                    </Button>
                                                                ) : null}
                                                                <Button
                                                                    className="btn submit-btn w-100 blue-btn text-uppercase"
                                                                    onClick={() => handleStake(fromWei(stakeAmount))}
                                                                    style={{ width: "100%" }}
                                                                    disabled={disabledStakeButton()}
                                                                >
                                                                    {pool.poolSymbol == "IGSP"
                                                                        ? "Closed Pool"
                                                                        : stakeAmount > idoBalance
                                                                          ? "Insufficient balance!"
                                                                          : !processing
                                                                            ? "Stake FIDO"
                                                                            : "Processing... "}
                                                                    {processing ? (
                                                                        <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                    ) : null}
                                                                </Button>
                                                            </FormGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="spacing"></div>

                                            <div className="your-details-right-box tokens-wrap">
                                                <div className="stake-bg d-flex flex-wrap justify-content-between div">
                                                    <div className="stake-bg-left tokens">
                                                        <CardText className="card-text-label text-uppercase">Available USDC Reward</CardText>
                                                        <div className="stake-bg-right tokens">
                                                            <Table borderless>
                                                                <tbody>
                                                                    {/* {testClaimableRewards.map((token, idx) => { */}
                                                                    {claimableRewards.map((token, idx) => {
                                                                        return (
                                                                            <tr className="your-details-table-row" key={idx}>
                                                                                <td>Token ID {token.id}: </td>
                                                                                <td>{token.reward} USDC</td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="stake-bg d-flex flex-wrap align-items-center justify-content-between">
                                                    <div className="stake-bg-left avail-reward">
                                                        <CardText className="card-text-label text-uppercase">Available USDC Reward</CardText>
                                                    </div>
                                                    <div className="stake-bg-right withdraw-reward">
                                                        <FormGroup>
                                                            <Input
                                                                disabled={!stakeIds.length || processing}
                                                                type="select"
                                                                value={selectedId}
                                                                onChange={(e) => setSelectedId(e.target.value)}
                                                                className="form-control w-100 reward-token-id"
                                                                placeholder="Select Token ID"
                                                            >
                                                                <option>Select the Token ID</option>
                                                                {stakeIds.map((id) => (
                                                                    <option key={id.value}>{id.value}</option>
                                                                ))}
                                                            </Input>
                                                            <div className="select-balance">
                                                                <CardText className="card-text-label text-uppercase">
                                                                    <span
                                                                        className="amount-value"
                                                                        onClick={() => {
                                                                            setClaimAmount(maxRewardsById)
                                                                        }}
                                                                    >
                                                                        max
                                                                    </span>
                                                                </CardText>
                                                            </div>
                                                            <Input
                                                                disabled={!(selectedId > 0) || !stakeIds.length || processing}
                                                                type="number"
                                                                min={0}
                                                                value={claimAmount}
                                                                onFocus={(e) => e.target.select()}
                                                                onChange={(e) => onRewardValueChange(e, "claim")}
                                                                className="form-control w-100"
                                                                placeholder="Enter reward amount"
                                                            ></Input>
                                                            {/* {maxRewardsById > 0 && <FormText>Maximum rewards for claim {maxRewardsById}</FormText>} */}

                                                            <Button
                                                                disabled={disabledClaimButton()}
                                                                color="success"
                                                                className="btn btn-primary submit-btn w-100 orange-btn text-uppercase"
                                                                onClick={() => handleClaim(null, selectedId, claimAmount)}
                                                                style={{ width: "100%" }}
                                                            >
                                                                {claimAmount > maxRewardsById
                                                                    ? "Insufficient balance!"
                                                                    : !processing
                                                                      ? "Withdraw Reward"
                                                                      : "Processing... "}
                                                                {processing ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Withdraw Stake</CardTitle>
                                        <Row className="stake-bg withdraw-stake-wrap">
                                            <FormGroup>
                                                <Row className="withdraw-stake">
                                                    <Col lg={4} className="col-md-6">
                                                        <label className="form-label">StakeToken ID</label>
                                                        <Input
                                                            disabled={!stakeIds.length || processing}
                                                            value={selectedId}
                                                            name="stakeIds"
                                                            id="stakeIds"
                                                            type="select"
                                                            onChange={(e) => {
                                                                setSelectedId(e.target.value)
                                                            }}
                                                        >
                                                            <option>Select the Stake ID</option>
                                                            {stakeIds.map((id) => (
                                                                <option key={id.value}>{id.value}</option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                    <Col lg={4} className="col-xl-3 col-md-6 mt-3 mt-md-0">
                                                        <div className="label-with-max">
                                                            <label className="form-label">Amount</label>
                                                            <div className="select-balance">
                                                                <CardText className="card-text-label text-uppercase">
                                                                    <span
                                                                        className="amount-value"
                                                                        onClick={() => {
                                                                            setInputUnStakeAmount(fromWei(maxWithdrawById))

                                                                            setUnStakeAmount(maxWithdrawById)
                                                                        }}
                                                                    >
                                                                        max
                                                                    </span>
                                                                </CardText>
                                                            </div>
                                                        </div>
                                                        <Input
                                                            // value={unStakeAmount}
                                                            type="number"
                                                            min={0}
                                                            className="form-control"
                                                            value={inputUnStakeAmount}
                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e) => onRewardValueChange(e, "unstake")}
                                                            placeholder="Enter Amount"
                                                            disabled={!(selectedId > 0) || !stakeIds.length || processing}
                                                        ></Input>
                                                        {/* {maxWithdrawById > 0 && <FormText>Maximum amount for withdrawal {maxWithdrawById}</FormText>} */}
                                                    </Col>
                                                    <Col lg={4} className="col-xl-3 mt-3 mt-lg-0">
                                                        <label className="form-label d-none d-lg-block">&nbsp;</label>
                                                        <Button
                                                            className="btn btn-primary orange-btn text-uppercase"
                                                            onClick={() => handleUnStake(selectedId, fromWei(unStakeAmount))}
                                                            disabled={disabledUnstakeButton()}
                                                            style={{ width: "100%" }}
                                                        >
                                                            {unStakeAmount > maxWithdrawById
                                                                ? "Insufficient balance!"
                                                                : !processing
                                                                  ? "Withdraw Stake"
                                                                  : "Processing... "}
                                                            {processing ? (
                                                                <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                            ) : null}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default Staking
